import axios from "axios";
import { useEffect, useState } from "react";
import { Container, Table } from "react-bootstrap";
import { root_url } from "../setting";
import { getBearerString } from "../utils/Auth";
const AdminSummary = () => {
  const styles = {
    backgroundColor: `rgb(228, 6, 19)`,
    color: "white",
  };

  const [resultPaidByGender, setResultPaidByGender] = useState([]);
  const [resultByGender, setResultByGender] = useState([]);
  const [resultByAge, setResultByAge] = useState([]);
  const [resultByRegion, setResultByRegion] = useState([]);
  const [resultByDaejeon, setResultByDaejeon] = useState([]);
  const [loading, setLoading] = useState(false);

  const getResultPaidByGender = async () => {
    let accessToken = getBearerString();
    console.log("여기확인해보자");
    console.log(accessToken);
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    try {
      let response = await axios.get(
        `${root_url}/api/admin/application/rollupPaidByGender`,
        headers
      );
      console.log(response.data);
      setResultPaidByGender(response.data);
    } catch (e) {
      if (e?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
      if (e.response === undefined) {
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      } else {
        alert(e.response.data.errorMessage);
      }
    }
  };

  const getResultByGender = async () => {
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    try {
      let response = await axios.get(
        `${root_url}/api/admin/application/rollupByGender`,
        headers
      );
      console.log(response.data);
      setResultByGender(response.data);
    } catch (e) {
      if (e?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
      if (e.response === undefined) {
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      } else {
        alert(e.response.data.errorMessage);
      }
    }
  };

  const getResultByAge = async () => {
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    try {
      let response = await axios.get(
        `${root_url}/api/admin/application/rollupByAge`,
        headers
      );
      console.log(response.data);
      setResultByAge(response.data);
    } catch (e) {
      if (e?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
      if (e.response === undefined) {
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      } else {
        alert(e.response.data.errorMessage);
      }
    }
  };
  const getResultByRegion = async () => {
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    try {
      let response = await axios.get(
        `${root_url}/api/admin/application/rollupByRegion`,
        headers
      );
      console.log(response.data);
      setResultByRegion(response.data);
    } catch (e) {
      if (e?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
      if (e.response === undefined) {
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      } else {
        alert(e.response.data.errorMessage);
      }
    }
  };
  const getResultByDaejeon = async () => {
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    try {
      let response = await axios.get(
        `${root_url}/api/admin/application/rollupByDaejeon`,
        headers
      );
      console.log(response.data);
      setResultByDaejeon(response.data);
    } catch (e) {
      if (e?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
      if (e.response === undefined) {
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      } else {
        alert(e.response.data.errorMessage);
      }
    }
  };

  useEffect(() => {
    getResultPaidByGender();
    getResultByGender();
    getResultByAge();
    getResultByRegion();
    getResultByDaejeon();
  }, []);
  return (
    <Container>
      <h1 id="outline" className="mt-5 pt-3 text-center">
        접수 현황
      </h1>
      <h3 id="outline" className="mt-3 text-left">
        성별
      </h3>
      <Table bordered className="text-center">
        <tr style={styles} className="bg-custom-color">
          <td rowspan="2" style={{ width: "20%" }}>
            코스구분
          </td>
          <td colspan="3">합계</td>
          <td colspan="3">개인신청</td>
          <td colspan="3">단체신청</td>
        </tr>
        <tr style={styles} className="bg-custom-color">
          <td>계</td>
          <td>남</td>
          <td>여</td>
          <td>계</td>
          <td>남</td>
          <td>여</td>
          <td>계</td>
          <td>남</td>
          <td>여</td>
        </tr>
        {resultByGender.map((item, key) => {
          return (
            <tr>
              <td>{item.raceName}</td>
              <td>{item.total}</td>
              <td>{item.maleTotal}</td>
              <td>{item.femaleTotal}</td>
              <td>{item.individual}</td>
              <td>{item.individualMale}</td>
              <td>{item.individualFemale}</td>
              <td>{item.party}</td>
              <td>{item.partyMale}</td>
              <td>{item.partyFemale}</td>
            </tr>
          );
        })}
      </Table>
      <h1 id="outline" className="mt-5 pt-3 text-center">
        등록 현황
      </h1>
      <h3 id="outline" className="mt-3 text-left">
        성별
      </h3>
      <Table bordered className="text-center">
        <tr style={styles} className="bg-custom-color">
          <td rowspan="2" style={{ width: "20%" }}>
            코스구분
          </td>
          <td colspan="3">합계</td>
          <td colspan="3">개인신청</td>
          <td colspan="3">단체신청</td>
        </tr>
        <tr style={styles} className="bg-custom-color">
          <td>계</td>
          <td>남</td>
          <td>여</td>
          <td>계</td>
          <td>남</td>
          <td>여</td>
          <td>계</td>
          <td>남</td>
          <td>여</td>
        </tr>
        {resultPaidByGender.map((item, key) => {
          return (
            <tr>
              <td>{item.raceName}</td>
              <td>{item.total}</td>
              <td>{item.maleTotal}</td>
              <td>{item.femaleTotal}</td>
              <td>{item.individual}</td>
              <td>{item.individualMale}</td>
              <td>{item.individualFemale}</td>
              <td>{item.party}</td>
              <td>{item.partyMale}</td>
              <td>{item.partyFemale}</td>
            </tr>
          );
        })}
      </Table>
      <h3 id="outline" className="mt-3 text-left">
        연대별
      </h3>
      <Table bordered className="text-center">
        <tr style={styles} className="bg-custom-color">
          <td rowspan="2" style={{ width: "20%" }}>
            코스구분
          </td>
          <td colspan="3">합계</td>
          <td colspan="3">30대 미만</td>
          <td colspan="3">30대</td>
          <td colspan="3">40대</td>
          <td colspan="3">50대</td>
          <td colspan="3">60대 이상</td>
        </tr>
        <tr style={styles} className="bg-custom-color">
          <td>계</td>
          <td>남</td>
          <td>여</td>
          <td>계</td>
          <td>남</td>
          <td>여</td>
          <td>계</td>
          <td>남</td>
          <td>여</td>
          <td>계</td>
          <td>남</td>
          <td>여</td>
          <td>계</td>
          <td>남</td>
          <td>여</td>
          <td>계</td>
          <td>남</td>
          <td>여</td>
        </tr>
        {resultByAge.map((item, key) => {
          return (
            <tr>
              <td>{item.raceName}</td>
              <td>{item.total}</td>
              <td>{item.maleTotal}</td>
              <td>{item.femaleTotal}</td>
              <td>{item.sum29}</td>
              <td>{item.male29}</td>
              <td>{item.female29}</td>
              <td>{item.sum30}</td>
              <td>{item.male30}</td>
              <td>{item.female30}</td>
              <td>{item.sum40}</td>
              <td>{item.male40}</td>
              <td>{item.female40}</td>
              <td>{item.sum50}</td>
              <td>{item.male50}</td>
              <td>{item.female50}</td>
              <td>{item.sum60}</td>
              <td>{item.male60}</td>
              <td>{item.female60}</td>
            </tr>
          );
        })}
      </Table>
      <h3 id="outline" className="mt-5">
        지역별
      </h3>
      <Table bordered className="text-center mb-5">
        <tr style={styles} className="bg-custom-color">
          <td style={{ width: "20%" }}>코스구분</td>
          <td>합계</td>
          <td>대전</td>
          <td>서울</td>
          <td>부산</td>
          <td>인천</td>
          <td>광주</td>
          <td>대구</td>
          <td>울산</td>
          <td>세종</td>
          <td>강원</td>
          <td>경기</td>
          <td>충북</td>
          <td>충남</td>
          <td>전북</td>
          <td>전남</td>
          <td>경북</td>
          <td>경남</td>
          <td>제주</td>
        </tr>
        {resultByRegion.map((item, key) => {
          return (
            <tr>
              <td>{item.raceName}</td>
              <td>{item.total}</td>
              <td>{item.daejeon}</td>
              <td>{item.seoul}</td>
              <td>{item.busan}</td>
              <td>{item.incheon}</td>
              <td>{item.gwangju}</td>
              <td>{item.daegu}</td>
              <td>{item.ulsan}</td>
              <td>{item.sejong}</td>
              <td>{item.gangwon}</td>
              <td>{item.kyonggi}</td>
              <td>{item.chungbuk}</td>
              <td>{item.chungnam}</td>
              <td>{item.jeonbuk}</td>
              <td>{item.jeonnam}</td>
              <td>{item.gyeongbuk}</td>
              <td>{item.gyeongnam}</td>
              <td>{item.jeju}</td>
            </tr>
          );
        })}
      </Table>
      <h3 id="outline" className="mt-5">
        대전지역별
      </h3>
      <Table bordered className="text-center mb-5">
        <tr style={styles} className="bg-custom-color">
          <td style={{ width: "20%" }}>코스구분</td>
          <td>합계</td>
          <td>대덕구</td>
          <td>동구</td>
          <td>중구</td>
          <td>서구</td>
          <td>유성구</td>
        </tr>
        {resultByDaejeon.map((item, key) => {
          return (
            <tr>
              <td>{item.raceName}</td>
              <td>{item.total}</td>
              <td>{item.daedeok}</td>
              <td>{item.donggu}</td>
              <td>{item.junggu}</td>
              <td>{item.seogu}</td>
              <td>{item.youseong}</td>
            </tr>
          );
        })}
      </Table>
    </Container>
  );
};

export default AdminSummary;
